<template>
	<section class="page portfolio-page p-3">
		<div class="portfolio-wrap pt-5 pb-5">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12 col-sm-12 col-md-3 arrow-top-left">
						<h2 class="mb-4">My works</h2>
					</div>
					<div class="col">
						<div class="row">
							<div
								v-for="(image, imageID) in image_info" 
								:key="imageID"
								class="col-12 col-sm-6 col-md-4 p-0 mb-3 mb-sm-0">

								<div id="photoWrapper" :style="{ height: height + 'px' }" class="photo-block bg-gradient-violet">
									<div class="image w-100 h-100">
										<img :src="image.min_src" alt="">
									</div>
									<div 
										@click="modal_open = true, modalBlockOpen( image.src, image.title, image.link_to, image.technology )"
										class="btn border border-white text-white">{{ buttonName }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<transition name="scale-in">
			<div v-if="modal_open" class="modal_block">
				<div 
					@click="modal_open = !modal_open"
					class="close_button pos-top-right">
					<i class="fas fa-times"></i>
				</div>
				<div class="container-fluid">
					<div class="row">
						<div class="col-12 col-md-4">
							<h3>{{ current_title }}</h3>
							<ul class="list-group list-group-flush mt-5 mb-5">
								<li
									class="list-group-item"
									v-for="(tech, techId) in current_technology"
									:key="techId"
								>
									<i class="far fa-check-circle text-primary mr-3"></i>
									<span>{{tech.name}}</span>
								</li>
							</ul>
							<a class="btn btn-white boreder border-dark text-dark rounded-0 mb-3" :href="current_link_to">open</a>
						</div>
						<div class="col-12 col-md-8">
							<img class="w-100" :src="current_src" alt="iamge">
						</div>
					</div>
				</div>
			</div>	
		</transition>
	</section>
</template>

<script>
export default {
	data () {
		return {
			id: 2,
			active: false,
			header: 'Мои работы',
			buttonName: 'Посмотреть',
			modal_open: false,
			height: 0,
			current_src: '',
			current_link_to: '',
			current_title: '',
			current_technology: [],
			image_info: [
				{
					src: require('../assets/images/Screenshot_2019-01-10 Y S-min.jpg'),
					min_src: require('../assets/images/min/Screenshot_2019-01-10 Y S-min.jpg'),
					link_to: 'https://uhonogo.github.io/buildcomputer',
					title: 'Дизайн-студия',
					technology: [
						{
							name: 'VueJS'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				},
				{
					src: require('../assets/images/dark_image-min.jpg'),
					min_src: require('../assets/images/min/dark_image-min.jpg'),
					link_to: 'https://uhonogo.github.io/portfolio/',
					title: 'Персональное порифолио',
					technology: [
						{
							name: 'Jquery'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				},
				{
					src: require('../assets/images/house-min.jpg'),
					min_src: require('../assets/images/min/house-min.jpg'),
					link_to: 'https://uhonogo.github.io/personal-portfolio/',
					title: 'Портфолио',
					technology: [
						{
							name: 'Jquery'
						},
						{
							name: 'Owl Carousel'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				},
				{
					src: require('../assets/images/htmb-min.jpg'),
					min_src: require('../assets/images/min/htmb-min.jpg'),
					link_to: 'https://uhonogo.github.io/star-toys',
					title: 'Детские игрушки',
					technology: [
						{
							name: 'VueJS'
						},
						{
							name: 'Owl Carousel'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				},
				{
					src: require('../assets/images/template_screenshot-min.jpg'),
					min_src: require('../assets/images/min/template_screenshot-min.jpg'),
					link_to: 'https://uhonogo.github.io/butterbroad',
					title: 'Лендинг',
					technology: [
						{
							name: 'VueJs'
						},
						{
							name: 'Parallax Effects'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				},
				{
					src: require('../assets/images/landing-min.jpg'),
					min_src: require('../assets/images/min/landing-min.jpg'),
					link_to: 'https://uhonogo.github.io/your-yoga',
					title: 'Yoga School',
					technology: [
						{
							name: 'Jquery'
						},
						{
							name: 'Owl carousel'
						},
						{
							name: 'Modal Pop-up'
						},
						{
							name: 'CSS Grid'
						},
						{
							name: 'Bootstrap 4'
						},
						{
							name: 'SASS'
						},
						{
							name: 'FontAwesome'
						},
					],
					visible: false,
					active: false
				}
			]
		}
	},
	methods: {
		modalBlockOpen (image, title, link, technology) {
			this.current_src = image
			this.current_link_to = link
			this.current_title = title
			this.current_technology = technology

			document.getElementById('app').style('overflow-y', 'hidden')
		},
		calculateWidth () {
			this.height = document.getElementById('photoWrapper').clientWidth
		},
		onClickChild () {
			this.$emit('clicked', {
				page_id: this.id,
				next_page: '/form',
				prev_page: '/skills'
			})
		}
	},
	mounted() {
		this.$nextTick(function() {
			window.addEventListener('resize', this.calculateWidth);

			this.calculateWidth()
			this.onClickChild()
		})
	},
}
</script>



// WEBPACK FOOTER //
// src/pages/portfolio.vue